import { baseApi } from 'segments/api/baseApi';

import { adapteCourtsList } from '../utils/adapter';
import { transformCourtInfo } from '../utils/transformer';

import type {
  UpdateCourtParams,
  CourtsList,
  CreateCourtParams,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourtsList: builder.query<CourtsList, void>({
      query: () => ({
        url: '/admin/courts/list',
        method: 'GET',
      }),
      transformResponse: adapteCourtsList,
      providesTags: ['CourtsList'],
      keepUnusedDataFor: 1,
    }),

    createCourt: builder.mutation<unknown, CreateCourtParams>({
      query: (formData: CreateCourtParams) => ({
        url: '/admin/courts/create',
        method: 'POST',
        body: transformCourtInfo(formData)
      }),
      invalidatesTags: ['CourtsList', 'CourtsBooking'],
    }),

    deleteCourt: builder.mutation<unknown, number>({
      query: (id: number) => ({
        url: `/admin/courts/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CourtsList', 'CourtsBooking'],
    }),

    updateCourt: builder.mutation<unknown, UpdateCourtParams>({
      query: ({ id, ...formData }: UpdateCourtParams) => ({
        url: `/admin/courts/update/${id}`,
        method: 'PUT',
        body: transformCourtInfo(formData),
      }),
      invalidatesTags: ['CourtsList'],
    }),
  }),
});

export const {
  useGetCourtsListQuery,
  useUpdateCourtMutation,
  useDeleteCourtMutation,
  useCreateCourtMutation
} = api;
